import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const slides = [
  {
    image: "/images/prd.jpg",
    title: "Premium Window Blinds",
    subtitle: "Transform your space with elegance & style.",
  },
  {
    image: "/images/valueblinds-1.jpg",
    title: "Modern & Sleek Designs",
    subtitle: "Experience luxury with our custom-made blinds.",
  },
  {
    image: "/images/home.jpg",
    title: "Stylish & Functional",
    subtitle: "Perfect blend of design and practicality for any room.",
  },
];


const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
  };

  return (
    <div className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      <AnimatePresence>
        {slides.map((slide, index) => (
          index === currentIndex && (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 1.02 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 1.02 }}
              transition={{ duration: 1, ease: "easeInOut" }}
              className="absolute inset-0 w-full h-full bg-cover bg-center"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="absolute inset-0 bg-black/40"></div>
              <motion.div
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 1, delay: 0.3 }}
                className="absolute w-full text-center text-white top-1/2 transform -translate-y-1/2 px-8"
              >
                <h1 className="text-4xl md:text-6xl font-bold drop-shadow-lg">{slide.title}</h1>
                <p className="mt-4 text-lg md:text-xl text-gray-300">{slide.subtitle}</p>
              </motion.div>
            </motion.div>
          )
        ))}
      </AnimatePresence>

      {/* Navigation */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white bg-black/50 p-3 rounded-full text-xl hover:bg-white/30 transition-all"
      >
        <FaChevronLeft />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white bg-black/50 p-3 rounded-full text-xl hover:bg-white/30 transition-all"
      >
        <FaChevronRight />
      </button>

      {/* Indicators */}
      <div className="absolute bottom-6 flex gap-2">
        {slides.map((_, index) => (
          <motion.div
            key={index}
            className={`w-3 h-3 rounded-full ${currentIndex === index ? "bg-white scale-125 shadow-lg" : "bg-gray-500/60"} transition-all`}
            whileHover={{ scale: 1.2 }}
            onClick={() => setCurrentIndex(index)}
          ></motion.div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;